import { createI18n } from 'vue-i18n'
import enGB from '@/i18n/locales/en-GB.json'

const APP_I18N_LOCALE = import.meta.env.VITE_APP_I18N_LOCALE

const i18n = createI18n({
  fallbackLocale: APP_I18N_LOCALE || 'en-GB',
  globalInjection: true,
  legacy: false,
  locale: APP_I18N_LOCALE || 'en-GB',
  messages: { 'en-GB': enGB },
})

export default i18n
